import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TimeframeComponent } from '../season-creation-timeframe/timeframe.component';
import { BudgetComponent } from '../season-creation-budget/budget.component';
import { SocialCriteriaComponent } from '../season-creation-social-criteria/social-criteria.component';
import { SalaryWeightComponent } from '../season-creation-salary-weight/salary-weight.component';
import { TranslateModule } from '@ngx-translate/core';
import { SeasonFormGroup } from '../../../models/season-form.model';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TimeframeComponent, BudgetComponent, SocialCriteriaComponent, SalaryWeightComponent, TranslateModule]
})
export class SummaryComponent {
    public readonly timeframe = input<SeasonFormGroup['timeframe']>();
    public readonly budget = input<SeasonFormGroup['budget']>();
    public readonly socialCriteria = input<SeasonFormGroup['socialCriteria']>();
    public readonly salaryWeight = input<SeasonFormGroup['salary']>();

    public hasSummaryPageBeenReached = false;
}
